// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/nexus/integrations/integrations.actions.go

import { type Scope } from "~/hooks/useScope";
import { LIST_DISCOVERY_RESULTS } from "./action";

export function canListDiscoveryResults(scope: Scope): boolean {
  return scope.iamActions.includes(LIST_DISCOVERY_RESULTS);
}
